// extracted by mini-css-extract-plugin
export default {"continueWithEmailButton":"kTr6_m1upY_yXz62cRgm","continueWithEmailButtonText":"FEUvEfFoKseO113v5r8W"};